import { $vfp } from '@/lib/vueFinalPopover';
/**
 * Xử lý hiển thị popup
 */
class PopoverUtil {
  /**
   * Đối tượng cache lại các component popup
   */
  _components = {};

  /**
   * Danh sách các popup đang hiển thị
   * key: tên popup
   * value: instance
   */
  _visible = {};

  /**
   * Mở popover
   * @param {string} name : Tên định danh
   * @param {*} target : Target element để leo popover
   * @param {object} params : tham số
   */
  show(name, target, params) {
    if (!name) throw 'name is required';
    if (!target) throw 'target is required';
    let ps = params || {};
    ps.name = name;
    ps.target = target;

    const popover = $vfp.show({ component: name }, ps);
    console.log(`popover name: ${name}`);
    return popover;
  }

  /**
   * Đóng tất cả popup đang mở
   */
  hideAll() {
    $vfp.hideAll();
  }
}

export default new PopoverUtil();
